import { needsFieldName } from '@developerz/domain';
import { For, type JSX } from 'solid-js';
import { t } from '../i18n';
import type { BlockerNeeds as Needs } from '../lib/blockers';
import { BlockerNeedsField } from './BlockerNeedsField';

// What a `missing_credential` asks a human to supply — the v2 needs FORM
// (`{ version: 2, fields[], landed[] }`, epic #3756) — one row per field, each
// marked supplied or outstanding. Presenter: the card decides whether the row
// has a form at all.
//
// NAMES ONLY, and that is a CONTRACT rather than a filter applied here.
// `blockers.needs` is plaintext jsonb projected on every read, so the write seam
// (`BlockerNeedsWriteSchema`) refuses a credential-shaped string and refuses
// `prod` outright, and `landed` records WHICH fields arrived, by name, never what
// they held. Rendering the form is safe for the same reason the API may serve it.
//
// "Supplied" is `needsFieldName(field) ∈ landed` — the domain's one naming rule
// (vault kinds bare, `mcp:` / `oauth:` prefixed), never a second copy of it here.
//
// The names-only line is not decoration — it is for the reader who is one
// control away from typing into the answer box, which is the field a pasted
// secret would actually land in.

export function BlockerNeeds(props: { readonly needs: Needs }): JSX.Element {
  const landed = (): ReadonlySet<string> => new Set(props.needs.landed);
  return (
    <div class="blocker-needs">
      <h3 class="blocker-needs__title">{t('blockers.needs_title')}</h3>
      <p class="card__desc">
        {t('blockers.needs_progress', {
          landed: props.needs.landed.length,
          total: props.needs.fields.length,
        })}
      </p>
      <ul class="blocker-needs__fields">
        <For each={props.needs.fields}>
          {(field) => (
            <BlockerNeedsField field={field} landed={landed().has(needsFieldName(field))} />
          )}
        </For>
      </ul>
      <p class="card__desc">{t('blockers.needs_names_only')}</p>
    </div>
  );
}
